import { lazy } from "react";

const ProveedoresLayout = lazy(() =>
      import("../../proveedores/ProveedoresLayout.jsx")
);

const Proveedores = lazy(() =>
      import("../../proveedores/Proveedores.jsx")
);

const ProveedorForm = lazy(() =>
      import("../../proveedores/ProveedorForm.jsx")
);

const ProveedoresCompras = lazy(() =>
      import("../../proveedores/ProveedoresCompras.jsx")
);

const proveedoresRoutes = [
      {
            path: "proveedores",
            element: <ProveedoresLayout />,
            children: [
                  { index: true, element: <Proveedores /> },
                  { path: "nuevo", element: <ProveedorForm /> },
                  { path: "editar/:token", element: <ProveedorForm /> },
                  { path: "compras/:token", element: <ProveedoresCompras /> },
            ],
      },
];

export default proveedoresRoutes;